import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useFirebase } from '../contexts/FirebaseContext';
import CreatePost from '../components/CreatePost';
import Post from '../components/Post';

const Home = () => {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useFirebase();

  useEffect(() => {
    const postsQuery = query(
      collection(db, 'posts'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(postsQuery, async (snapshot) => {
      const postsData = await Promise.all(snapshot.docs.map(async (docSnapshot) => {
        const postData = docSnapshot.data();
        
        // Ensure likes array exists
        if (!postData.likes) {
          postData.likes = [];
        }

        // Get user's bookmarks
        if (currentUser) {
          const userDocRef = doc(db, 'users', currentUser.uid);
          const userDocSnapshot = await getDoc(userDocRef);
          const userData = userDocSnapshot.data();
          if (userData?.bookmarks?.includes(docSnapshot.id)) {
            postData.isBookmarked = true;
          }
        }

        return {
          id: docSnapshot.id,
          ...postData
        };
      }));

      setPosts(postsData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  if (!currentUser) return null;

  return (
    <div>
      <div className="border-b border-gray-800 sticky top-0 bg-gray-900/80 backdrop-blur-sm z-10">
        <h1 className="text-xl font-bold p-4">Home</h1>
      </div>

      <CreatePost />

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-purple-500 border-t-transparent"></div>
        </div>
      ) : posts.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p className="text-lg">No posts yet</p>
          <p className="text-sm">Be the first to post something!</p>
        </div>
      ) : (
        <div>
          {posts.map((post) => (
            <Post
              key={post.id}
              post={post}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Home;